import { NotificationSettingsIndex } from '@/Workspaces/NotificationSettings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/notificationSettings/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <NotificationSettingsIndex />
}
